import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

import index from '@/components/mode/index'
import index_old from '@/components/mode/index_old'
import app from '@/components/mode/app'
import kefu from '@/components/mode/kefu'
import gamePage from '@/components/mode/gamePage'
import hongbao from '@/components/mode/hongbao'
import activity from '@/components/mode/activity'
import activity_old from '@/components/mode/activity_old'
import zhanzhu from '@/components/mode/zhanzhu'
import mine from '@/components/mode/mine'
import mine_old from '@/components/mode/mine_old'
import lotteryPage from '@/components/mode/lotteryPage.vue'


import login from '@/components/login'
import activityInfo from '@/components/activityInfo'
import zhanzhuye from '@/components/zhanzhuye'
import vip from '@/components/vip'
import applyagent from '@/components/applyagent'
import boutBallBet from '@/components/boutBallBet'
import boutBallBetInfo from '@/components/boutBallBetInfo'
import message from '@/components/message'
import fanshui from '@/components/fanshui'
import userInfo from '@/components/userInfo'
import userCent from '@/components/userCent'
import wallet from '@/components/wallet'
import addUsdtCard from '@/components/addUsdtCard'
import addBankCard from '@/components/addBankCard'
import usdtmore from '@/components/usdtmore'
import password from '@/components/password'
import welfare from '@/components/welfare'
import betRecord from '@/components/betRecord'
import betDetail from '@/components/betDetail'
import activityRecord from '@/components/activityRecord'
import transRecord from '@/components/transRecord'
import money from '@/components/money'
import recharge from '@/components/recharge'
import payInfo from '@/components/payInfo'
import withdrawal from '@/components/withdrawal'
import transfer from '@/components/transfer'
import concise from '@/components/mode/concise'
import dialogue from '@/components/dialogue'
import reg from '@/components/reg'
import reg2 from '@/components/reg2'
import iframepage from '@/components/iframepage'
import vip2 from '@/components/vip2'
import inviter from '@/components/inviter'
import withdrawAccount from '@/components/withdrawAccount'
import discover from '@/components/mode/discover'
import account from '@/components/account'
import cashbackRates from '@/components/fanshui_ratio'

import profitLoss from '@/components/mode/ProfitLoss'
import agentIndex from '@/components/agent/index'
import agentInfo from '@/components/agent/info'
import agentDirectPlayers from '@/components/agent/directPlayers'
import agentBills from '@/components/agent/bills'
import agentOverview from '@/components/agent/overview'
import agentStatistics from '@/components/agent/statistics'
import agentWithdraw from '@/components/agent/withdraw'
import agentRecharge from '@/components/agent/recharge'
import agentSubAgent from '@/components/agent/subAgent'
import agentSubOnline from '@/components/agent/subOnline'
import agentGiveAway from '@/components/agent/giveAway'

import gameRoom from '@/components/game/room'
import gameTrend from '@/components/game/trend'
import gameStatis from '@/components/game/statis'
import gameScratch from '@/components/game/scratch'
import gameList from '@/components/game/list'
import gameHall from '@/components/game/hall'

import languageSelection from '@/components/mode/language-selection'

import gameLiuhe from '@/components/Liuhe/list'
import gameLiuheRoom from '@/components/Liuhe/room'
import loadingPage from '@/components/mode/loading'




Vue.use(Router)

export default new Router({
  // mode: 'history',

  // meta: {
  //   requireAuth: true,
  //   keepAlive: true,//是否缓存组件
  //   useCatch:false//是否用缓存
  // }
  mode: 'hash',

  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main,
      children: [
        {
          path: '/',
          name: 'index',
          component: index,
          meta: {
            keepAlive: false,//是否缓存组件
            useCatch: true//是否用缓存
          }
        },{
          path: '/home',
          name: 'index',
          component: index,
          meta: {
            keepAlive: false,//是否缓存组件
            useCatch: true//是否用缓存
          }
        },
        {
          path: '/dialogue',
          name: 'dialogue',
          component: dialogue,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        },
        {
          path: '/discover',
          name: 'discover',
          component: discover,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        },{
          path: '/index_old',
          name: 'index_old',
          component: index_old,
          meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }
        }, {
          path: '/hongbao',
          name: 'hongbao',
          component: hongbao,

        },
        {
          path: '/activity',
          name: 'activity',
          component: activity, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        },{
          path: '/activity_old',
          name: 'activity_old',
          component: activity_old, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/zhanzhu',
          name: 'zhanzhu',
          component: zhanzhu, meta: {
            keepAlive: true,//是否缓存组件
            useCatch: false//是否用缓存
          }

        }, {
          path: '/mine',
          name: 'mine',
          component: mine, meta: {
            keepAlive: true,//是否缓存组件

            useCatch: false,//是否用缓存
            requireAuth: true,

          }
        },
        {
          path: '/mine_old',
          name: 'mine_old',
          component: mine_old, meta: {
            keepAlive: true,//是否缓存组件

            useCatch: false,//是否用缓存
            requireAuth: true,

          }
        },
        {
          path: '/app',
          name: 'app',
          component: app, meta: {
            keepAlive: true,//是否缓存组件

            useCatch: false,//是否用缓存
            requireAuth: true,

          }

        }
      ]
    }, {
      path: '/account',
      name: 'account',
      component: account,

    },{
      path: '/inviter',
      name: 'inviter',
      component: inviter,

    },{
      path: '/withdrawAccount',
      name: 'withdrawAccount',
      component: withdrawAccount,

    }, {
      path: '/vip2',
      name: 'vip2',
      component: vip2,

    }, {
      path: '/iframepage',
      name: 'iframepage',
      component: iframepage,

    },{
      path: '/kefu',
      name: 'kefu',
      component: kefu,

    },{
      path: '/login',
      name: 'login',
      component: login,
    },{
      path: '/reg',
      name: 'reg',
      component: reg,
    },{
      path: '/reg2',
      name: 'reg2',
      component: reg2,
    }, {
      path: '/gamePage',
      name: 'gamePage',
      component: gamePage,

    }, {
      path: '/lottery',
      name: 'lottery',
      component: lotteryPage
    }, {
      path: '/activityInfo',
      name: 'activityInfo',
      component: activityInfo,
    }, {
      path: '/zhanzhuye',
      name: 'zhanzhuye',
      component: zhanzhuye,
    },
    {
      path: '/vip',
      name: 'vip',
      component: vip,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    }, {
      path: '/applyagent',
      name: 'applyagent',
      component: applyagent,


    }, {
      path: '/boutBallBet',
      name: 'boutBallBet',
      component: boutBallBet,
    }, {
      path: '/boutBallBetInfo',
      name: 'boutBallBetInfo',
      component: boutBallBetInfo,
    }, {
      path: '/message',
      name: 'message',
      component: message, meta: {
        requireAuth: true,
      }
    }, {
      path: '/fanshui',
      name: 'fanshui',
      component: fanshui, meta: {
        requireAuth: true,
      }
    }, {
      path: '/userInfo',
      name: 'userInfo',
      component: userInfo,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/userCent',
      name: 'userCent',
      component: userCent,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/wallet',
      name: 'wallet',
      component: wallet,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/addBankCard',
      name: 'addBankCard',
      component: addBankCard,
      meta: {
        requireAuth: true,
      }
    }
    , {
      path: '/addUsdtCard',
      name: 'addUsdtCard',
      component: addUsdtCard,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/usdtmore',
      name: 'usdtmore',
      component: usdtmore,

    }, {
      path: '/password',
      name: 'password',
      component: password,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/welfare',
      name: 'welfare',
      component: welfare,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/betRecord',
      name: 'betRecord',
      component: betRecord,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/betDetail',
      name: 'betDetail',
      component: betDetail,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/activityRecord',
      name: 'activityRecord',
      component: activityRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/transRecord',
      name: 'transRecord',
      component: transRecord,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/money',
      name: 'money',
      component: money,
      meta: {
        requireAuth: true,
      }
    }, {
      path: '/recharge',
      name: 'recharge',
      component: recharge,
      meta: {
        requireAuth: true,
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }
    }, {
      path: '/payInfo',
      name: 'payInfo',
      component: payInfo,


    }, {
      path: '/concise',
      name: 'concise',
      component: concise,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: false//是否用缓存
      }

    },

    {
      path: '/withdrawal',
      name: 'withdrawal',
      component: withdrawal,
      meta: {
        requireAuth: true,

      }
    }, {
      path: '/transfer',
      name: 'transfer',
      component: transfer,
      meta: {
        requireAuth: true,

      }
    },
    {
      path: '/cashback-rates',
      name: 'cashback-rates',
      component: cashbackRates,
      meta: {
        requireAuth: true,

      }
    },
    {
      path: '/profit-loss',
      name: 'profit-loss',
      component: profitLoss,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-index',
      name: 'agent-index',
      component: agentIndex,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-info',
      name: 'agent-info',
      component: agentInfo,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-directPlayers',
      name: 'agent-directPlayers',
      component: agentDirectPlayers,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-bills',
      name: 'agent-bills',
      component: agentBills,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-overview',
      name: 'agent-overview',
      component: agentOverview,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-statistics',
      name: 'agent-statistics',
      component: agentStatistics,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-withdraw',
      name: 'agent-withdraw',
      component: agentWithdraw,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-recharge',
      name: 'agent-recharge',
      component: agentRecharge,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-subAgent',
      name: 'agent-subAgent',
      component: agentSubAgent,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-subOnline',
      name: 'agent-subOnline',
      component: agentSubOnline,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/agent-giveAway',
      name: 'agent-giveAway',
      component: agentGiveAway,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-room',
      name: 'game-room',
      component: gameRoom,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-trend',
      name: 'game-trend',
      component: gameTrend,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-statis',
      name: 'game-statis',
      component: gameStatis,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-scratch',
      name: 'game-scratch',
      component: gameScratch,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-list',
      name: 'game-list',
      component: gameList,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-hall',
      name: 'game-hall',
      component: gameHall,
      meta: {
        keepAlive: true,//是否缓存组件
        useCatch: true//是否用缓存
      }
    },
    {
      path: '/language-selection',
      name: 'language-selection',
      component: languageSelection,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-Liuhe',
      name: 'game-Liuhe',
      component: gameLiuhe,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/game-Liuhe-room',
      name: 'game-Liuhe-room',
      component: gameLiuheRoom,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '/loading',
      name: 'loading',
      component: loadingPage,
      meta: {
        requireAuth: true,
      }
    },
    {
      path: '*', // 重定向页面地址
      redirect: '/'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js